import React, { useEffect, useState } from 'react';
interface PageTransitionProps {
    children: React.ReactNode;
    duration?: number;
}
export function PageTransition({ children, duration = 500 }: PageTransitionProps) {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        // Start fade out immediately after mount
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, 10);
        return () => clearTimeout(timer);
    }, []);
    return (
        <>
            {/* Overlay that fades out */}
            <div
                className={`fixed inset-0 bg-brand-background z-50 pointer-events-none transition-opacity ${
                    isVisible ? 'opacity-100' : 'opacity-0'
                }`}
                style={{
                    transitionDuration: `${duration}ms`,
                    transitionTimingFunction: 'ease-out'
                }}
            />

            {children}
        </>
    );
}
